import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MpsUserService } from '../services/mps-user.service';
import { applicationRouteNames } from '../../app/application-route-names';
import { PermissionsHelper } from '../../app/helpers/permissions.helper';
import { MpsUser } from '../../app/models/mps-user.model';

export const MpsGuestGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return true;
  }

  const user = new MpsUser(loggedInUser);
   if (!PermissionsHelper.canAccessBackofficeApp(user)) {
    return true;
  }

  return router.navigateByUrl(applicationRouteNames.cylinderManagement);
};
